
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/api/products/assets",
      function () {
        return require("private-next-pages/docs/api/products/assets.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/api/products/assets"])
      });
    }
  